import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TAG_FEATURE_KEY, TagState } from './tag.reducer';

export const selectTagState = createFeatureSelector<TagState>(TAG_FEATURE_KEY);

export const selectTags = createSelector(selectTagState, (state) => state?.data ?? null);
export const selectTagDetail = createSelector(selectTagState, (state) => state?.detail ?? null);
export const selectTagsLoading = createSelector(selectTagState, (state) => state?.loading ?? false);
export const selectTagsError = createSelector(selectTagState, (state) => state?.error ?? null);
